import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { makeSelectDisplayScope } from "../../containers/App/selectors";
import { buildDealPath, DealTab } from "../../utils/dealRoutes";

type Props = {
  id: number;
  number: string;
  tab?: DealTab;
};

const DealLink = React.memo(({ id, number, tab }: Props) => {
  const displayScope = useSelector(makeSelectDisplayScope());

  if (displayScope === "ALL" || displayScope === "DEALS" || displayScope === "DEALS_TRACKING") {
    return <Link to={buildDealPath(id, tab)}>{number}</Link>;
  }

  return <span>{number}</span>;
});

export default DealLink;
